import MiSpace from './MiSpace.vue'

export default MiSpace
